import differenceInDays from 'date-fns/differenceInDays'
import uuid from 'uuid/v4';

import Cookie from '../cookie';
import SafeLocalStorage from '../storage/SafeLocalStorage';

export const ANONYMOUS_ID_KEY = 'ajs_anonymous_id';

export default class User {
  private store: SafeLocalStorage;
  private cookie: Cookie;

  private userId?: string;
  private lastAnonymousIdCookieUpdate?: number;

  constructor() {
    this.store = new SafeLocalStorage({
      useStoragePrefix: false,
    });
    this.cookie = new Cookie();
  }

  getUserId(): string | null {
    return this.userId || null;
  }

  setUserId(userId?: string) {
    this.userId = userId;
  }

  getAnonymousId(): string {
    // Prefer localStorage as there cant be duplicate keys, and its faster.
    const localstorageAnonid = this.store.getItem(ANONYMOUS_ID_KEY);
    if (localstorageAnonid) {
      const parsedAnonId = JSON.parse(localstorageAnonid);
      if (!this.lastAnonymousIdCookieUpdate || differenceInDays(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= 7) {
        this.setAnonymousId(parsedAnonId);
      }
      return parsedAnonId;
    } else {
      // If not set in localStorage, check cookies.
      const anonId = this.cookie.get(ANONYMOUS_ID_KEY);
      if (anonId) {
        const parsedAnonId = JSON.parse(anonId);
        this.store.setItem(ANONYMOUS_ID_KEY, anonId);
        return parsedAnonId;
      }
    }
    const newAnonId = uuid();
    this.setAnonymousId(newAnonId);
    return newAnonId;
  }

  setAnonymousId(userId: string) {
    this.cookie.set(ANONYMOUS_ID_KEY, JSON.stringify(userId));
    this.lastAnonymousIdCookieUpdate = Date.now();
    return this.store.setItem(ANONYMOUS_ID_KEY, JSON.stringify(userId));
  }
}
